import { fromJS } from 'immutable';

import { TextOverlayV2 } from '../types';

const gooeyTextMigration = (overlay: TextOverlayV2): TextOverlayV2 => {
  return overlay.withMutations(s => {
    // if gooeyText config is set for the overlay it means that the there
    // is no need for any migration.
    if (s.getIn(['advancedTextConfigs', 'gooeyText'])) {
      return s;
    }

    // if textHighlight style is not present it means that there is no need
    // for adding the gooey text config.
    if (!s.getIn(['editor', 'textStyle', 'textHighlight'])) {
      return s;
    }

    // when the text highlight is set, the gooey text config is extracted
    // from the highlight color and the radius set to 0
    s.setIn(
      ['advancedTextConfigs', 'gooeyText'],
      fromJS({
        color: s.getIn(['editor', 'textStyle', 'textHighlight']),
        radius: 0,
      }),
    );
    s.deleteIn(['editor', 'textStyle', 'textHighlight']);

    return s;
  });
};

export default gooeyTextMigration;
